

function handleContentLoaded() {
  const loadingElement = document.getElementById('js-loading');
  setTimeout(() => {
    if (!loadingElement.classList.contains('is-loaded')) {
      loadingElement.classList.add('is-loaded');
    }
  }, 3000);
}

// TOC
function generateTOC() {
  const toc = document.getElementById('js-toc');
  if (toc === null) return false;

  const content = document.getElementById('js-post-contents');
  const headers = Array.from(content.querySelectorAll('h1, h2, h3, h4, h5, h6'));

  toc.innerHTML = '';
  if (headers.length === 0) {
    return;
  }

  const dl = document.createElement('dl');
  dl.className = 'sec-custom-main-blog__post-toc-def';

  const dt = document.createElement('dt');
  dt.textContent = 'Index';
  dt.className = 'sec-custom-main-blog__post-toc-def-term';

  dl.appendChild(dt);

  const dd = document.createElement('dd');
  dd.className = 'sec-custom-main-blog__post-toc-def-desc';
  const ul = document.createElement('ul');
  ul.className = 'sec-custom-main-blog__post-toc-list';

  headers.forEach((header, index) => {
    const headerType = header.nodeName.toLowerCase();
    if (!header.id) {
      header.id = 'section-' + headerType + '-' + (index + 1);
    }
    const link = document.createElement('a');
    link.href = '#' + header.id;
    link.textContent = header.textContent;
    link.className = `sec-custom-main-blog__post-toc-link js-smooth-scroll is-${headerType}`;
    addSmoothScroll(link);
    const listItem = document.createElement('li');
    listItem.appendChild(link);
    listItem.className = 'sec-custom-main-blog__post-toc-list-item';
    ul.appendChild(listItem);
  });

  dd.appendChild(ul);
  dl.appendChild(dd);
  toc.appendChild(dl);
}

// swiper
const swiperArray = [];
const breakPoint = 989;
function swiperSlide() {
  const createSwiper = (elem) => {
    const id = '#' + elem.id;
    const type = elem.dataset.type;
    const autoplay = elem.dataset.autoplay;
    const speed = elem.dataset.speed;

    const nextSelecter = '.swiper-button-next';
    const prevSelecter = '.swiper-button-prev';
    const scrollbarSelecter = '.swiper-scrollbar';

    let autoPlayObj = false;
    if (autoplay == 'true') {
      const ms = speed * 1000;
      autoPlayObj = {
        delay: ms,
      }
    }
    const option = {
      autoplay: autoPlayObj,
      lazy: true,
      a11y: false,
      mousewheel: {
        sensitivity: 1.0,
        forceToAxis: true
      }
    };

    let slidesCopy = [];
    const copySlides = (elem) => {
      let slidesCopy = [];
      elem.querySelectorAll('.swiper-slide').forEach(slide => {
        let slideCopy = slide.outerHTML;

        // 新しいDOM要素としてパース
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = slideCopy;
        let newSlide = tempDiv.firstChild;

        // 最終的なHTMLをslidesCopy配列に追加
        slidesCopy.push(newSlide.outerHTML);
      });
      return slidesCopy;
    }

    let copyCount = 0;
    const adjustSlides = (copyCount, swiperObj, slidesCopy) => {
      if (copyCount > 0) {
        // 削除するスライドのインデックスの配列を生成
        const removeIndexes = Array.from({ length: slidesCopy.length }, (_, i) => i);
        swiperObj.removeSlide(removeIndexes);
      }
      swiperObj.appendSlide(slidesCopy);
      window.preloadImages();
    }
    // const adjustSlides = (swiperObj, slidesCopy) => {
    //   swiperObj.removeAllSlides();
    //   swiperObj.appendSlide(slidesCopy);
    //   window.preloadImages();
    // }

    switch (type) {
      case 'mainVisual':
        option.slidesPerView = 1;
        option.loop = true;
        option.effect = 'fade';
        option.sppped = 300;
        option.fadeEffect = {
          crossFade: true
        };
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
        }
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
          prevEl: id + ' ' + prevSelecter,
        };
        break;
      case 'all_products':
        option.slidesPerView = "auto";
        option.freeMode = true;
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
        }
        option.on = {
          // 初期化の際にスライドのコピーを取得
          init: () => {
            slidesCopy = copySlides(elem);
          },
          // スライドの移動が終了した時のイベント          
          reachEnd: () => {
            if (slidesCopy.length > 0) {
              adjustSlides(copyCount, swiperObj, slidesCopy);
              copyCount++;
              // adjustSlides(swiperObj, slidesCopy);
            }
          }
        }
        break;
      case 'aboutUs':
        option.slidesPerView = 1;
        option.loop = true;
        option.effect = 'fade';
        option.sppped = 300;
        option.fadeEffect = {
          crossFade: true
        };
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
          option.navigation = {
            nextEl: id + ' ' + nextSelecter,
            prevEl: id + ' ' + prevSelecter,
          };
        }
        break;
      case 'blog':
        option.slidesPerView = "auto";
        option.freeMode = true;
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
        }
        option.on = {
          // 初期化の際にスライドのコピーを取得
          init: () => {
            slidesCopy = copySlides(elem);
          },
          // スライドの移動が終了した時のイベント          
          reachEnd: () => {
            if (slidesCopy.length > 0) {
              adjustSlides(copyCount, swiperObj, slidesCopy);
              copyCount++;
              // adjustSlides(swiperObj, slidesCopy);
            }
          }
        }
        break;
      case 'ranking':
        option.slidesPerView = "auto";
        option.freeMode = true;
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
        }
        option.on = {
          // 初期化の際にスライドのコピーを取得
          init: () => {
            slidesCopy = copySlides(elem);
          },
          // スライドの移動が終了した時のイベント          
          reachEnd: () => {
            if (slidesCopy.length > 0) {
              adjustSlides(copyCount, swiperObj, slidesCopy);
              copyCount++;
              // adjustSlides(swiperObj, slidesCopy);
            }
          }
        }
        break;
      case 'collection':
        option.slidesPerView = 1;
        option.loop = true;
        option.effect = 'fade';
        option.sppped = 300;
        option.fadeEffect = {
          crossFade: true
        };
        if (document.querySelectorAll(id + ' ' + scrollbarSelecter).length > 0) {
          option.scrollbar = {
            el: id + ' ' + scrollbarSelecter
          };
        }
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
          prevEl: id + ' ' + prevSelecter,
        };
        break;
      default:
    }

    const swiperObj = new Swiper(id, option);
    swiperArray.push(swiperObj);
  };

  if (swiperArray.length > 0) {
    swiperArray.forEach((obj) => {
      if (obj.el.swiper.scrollbar.el) {
        obj.el.swiper.scrollbar.el.innerHTML = '';
      }
      obj.destroy();
    });
    swiperArray.splice(0, swiperArray.length);
  }
  document.querySelectorAll('.js-swiper').forEach(elem => createSwiper(elem));
}

// ページ内のスムーススクロール
const addSmoothScroll = (anchor) => {
  const headerHeight = document.querySelector('#js-fixed-header').offsetHeight;
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const scrollToPosition = targetPosition - headerHeight;
    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
  });
}
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"].js-smooth-scroll').forEach(anchor => {
    addSmoothScroll(anchor);
  });
}

// ページ読み込み時にハッシュリンクがある場合のスクロール
const scrollToHash = (hash) => {
  const headerHeight = document.querySelector('#js-fixed-header').offsetHeight;
  const target = document.querySelector(hash);
  if (target) {
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const scrollToPosition = targetPosition - headerHeight;
    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
  }
}
function handlePageLoad() {
  if (window.location.hash && window.location.search != '?customer_posted=true') {
    setTimeout(() => {
      scrollToHash(window.location.hash);
    }, 100);
  }
}

// アコーディオン
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.triggerElement = accordionElement.querySelector(".js-accordion__trigger");
    if (this.triggerElement) {
      this.triggerElement.addEventListener("click", () => {
        this.toggleAccordion();
      });
    }
  }
  toggleAccordion() {
    this.accordionElement.classList.toggle("is-active");
  }
}
function initializeAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}

// コレクションallの商品非同期読み込み
const loadMoreProducts = () => {
  const nextPage = document.querySelector('#js-collection-pagenation-next').getAttribute('href');
  const loadMoreButton = document.querySelector('#js-load-more');
  if (nextPage) {
    loadMoreButton.disabled = true;
    fetch(nextPage)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.text();
      })
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        const productData = doc.querySelectorAll('.s-custom-product-item');
        const newPageLink = doc.querySelector('#js-collection-pagenation-next') ? doc.querySelector('#js-collection-pagenation-next').getAttribute('href') : null;

        productData.forEach((item) => {
          document.querySelector('.s-custom-collection-layout__grid').appendChild(item);
          window.preloadImages(item);
        });

        history.pushState({}, null, nextPage);
        loadMoreButton.disabled = false;

        if (newPageLink) {
          document.querySelector('#js-collection-pagenation-next').setAttribute('href', newPageLink);
          loadMoreButton.classList.remove('is-hidden');
        } else {
          loadMoreButton.classList.add('is-hidden');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}
function initializeLoadMore() {
  const loadMoreButton = document.querySelector('#js-load-more');
  if (!loadMoreButton) return;
  const nextPageLink = document.querySelector('#js-collection-pagenation-next');
  if (nextPageLink && nextPageLink.getAttribute('href')) {
    loadMoreButton.addEventListener('click', loadMoreProducts);
    loadMoreButton.classList.remove('is-hidden');
  } else {
    loadMoreButton.classList.add('is-hidden');
  }
}
function observerLoadMore() {
  const targetNode = document.querySelector('.js-observe-container');
  if (!targetNode) return;
  const config = { childList: true, attributes: true };
  const observer = new MutationObserver(initializeLoadMore);
  observer.observe(targetNode, config);
}

// バリエーション用のダミーセレクトボックスとラジオボタンの連動
const updateVariantRadio = (selectBoxElem) => {
  const selectBox = selectBoxElem;
  const selectedValue = selectBox.value;
  const rsyncId = selectBox.dataset.rsyncId;
  const radioGroup = document.querySelectorAll(`[data-rsync-id="${rsyncId}"] .js-variant-radio`);
  for (let i = 0; i < radioGroup.length; i++) {
    if (radioGroup[i].value === selectedValue) {
      radioGroup[i].checked = true;
      radioGroup[i].dispatchEvent(new Event('change', { 'bubbles': true }));
      break;
    }
  }
}
function observeVariantSelect() {
  const selectBoxes = document.querySelectorAll('.js-variant-select');
  for (let i = 0; i < selectBoxes.length; i++) {
    selectBoxes[i].addEventListener('change', () => {
      updateVariantRadio(selectBoxes[i]);
    });
  }
}

// quantity
function adjustQuantity() {
  const buttons = document.querySelectorAll('.js-quantity-button');
  buttons.forEach(button => {
    // すでにイベントリスナーが設定されているか確認
    if (button.dataset.adjusted) return;

    const actions = button.closest('.js-quantity-actions');
    const input = actions.querySelector('.js-quantity-input');
    const minusButton = actions.querySelector('button[name="minus"]');

    // 読み込み時の処理：inputの値が1より大きい場合、minusButtonのdisabledを外す
    if (parseInt(input.value, 10) > 1) {
      minusButton.disabled = false;
    }

    button.addEventListener('click', (event) => {
      let inputValue = parseInt(input.value, 10);

      if (button.name === 'minus' && inputValue > 1) {
        input.value = inputValue - 1;
      } else if (button.name === 'plus') {
        input.value = inputValue + 1;
      }
      const inputEvent = new Event('input', {
        'bubbles': true,
        'cancelable': true
      });
      input.dispatchEvent(inputEvent);
      minusButton.disabled = input.value == 1;
    });

    // イベントリスナーを設定したことをマーク
    button.dataset.adjusted = "true";
  });
}

// store
function searchStore() {
  const storeSearchPref = document.querySelector('[name="store_search_pref"]');
  const storeSearchProduct = document.querySelector('[name="store_search_product"]');
  const storeSearchButton = document.getElementById('js-store-search-button');
  const storeSearchResults = document.getElementById('js-store-search-results');
  const storeSearchMap = document.getElementById('js-store-search-map');

  let STORES;

  function initSearch() {
    const jsonScript1 = document.querySelector('#stores-data-1');
    const jsonScript2 = document.querySelector('#stores-data-2');

    if (!jsonScript1 || !jsonScript2) return;

    // JSON文字列をオブジェクトにパース
    const stores1 = JSON.parse(jsonScript1.textContent);
    const stores2 = JSON.parse(jsonScript2.textContent);
    // データを結合
    let stores = stores1.concat(stores2);

    stores = stores.map(store => {
      store.google_map = encodeURIComponent(store.google_map);
      return store;
    });
    STORES = stores;
  }

  function doSearch() {
    storeSearchResults.innerHTML = '';
    storeSearchMap.innerHTML = '';
    const selectedPref = storeSearchPref.value;
    const selectedProduct = storeSearchProduct.value;

    const matchedStores = STORES.filter(store => {
      if (selectedPref && selectedProduct) {
        return store.pref === selectedPref && store.products.includes(selectedProduct);
      } else if (selectedPref) {
        return store.pref === selectedPref;
      } else if (selectedProduct) {
        return store.products.includes(selectedProduct);
      }
      return false;
      // どちらも選択されていない場合は、falseを返します。
    });

    if (matchedStores.length === 0) {
      storeSearchResults.innerHTML = '<p class="sec-custom-main-store__search-results-item-notes">対象店舗はありません</p>';
      return;
    }

    matchedStores.forEach((store, index) => {
      console.log('store', store);
      const products = store.products.map(product => {
        return `<li class="sec-custom-main-store__search-results-item-list-item">${product}</li>`;
      });
      const html = `
      <section class="sec-custom-main-store__search-results-item" data-map="${store.google_map}">
        <h3 class="sec-custom-main-store__search-results-item-name c-font-ja--b">${store.name}</h3>
        <p class="sec-custom-main-store__search-results-item-address">${store.address}</p>
        <p class="sec-custom-main-store__search-results-item-phone">${store.phone}</p>
        <p class="sec-custom-main-store__search-results-item-url">
          <a href="${store.url}" target="_blank">${store.url}</a>
        </p>
        <ul class="sec-custom-main-store__search-results-item-list">
          ${products.join('')}
        </ul>
      </section>`
        ;
      storeSearchResults.innerHTML += html;

      // 最初の店舗のマップを表示する
      if (index === 0) {
        const firstMapUrl = decodeURIComponent(store.google_map);
        storeSearchMap.innerHTML = firstMapUrl;
      }
    });

    const storeItems = document.querySelectorAll('.sec-custom-main-store__search-results-item');

    storeItems.forEach(item => {
      item.addEventListener('click', function () {
        const mapUrl = decodeURIComponent(this.dataset.map);
        storeSearchMap.innerHTML = mapUrl;
      });
    });
  }


  initSearch();
  if (!storeSearchButton) return;
  storeSearchButton.addEventListener('click', doSearch);
}

// トップページでの定期購入情報の表示
function subscriptionInfo() {
  const observeTarget = document.querySelector('#js-subscription-observe');
  if (!observeTarget) return;
  const infoElem = document.querySelector('#js-subscription-info');
  const buttonElem = document.querySelector('#js-subscription-info-close');
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.boundingClientRect.bottom <= window.innerHeight) {
        infoElem.classList.add('is-active');
      } else {
        infoElem.classList.remove('is-active');
      }
    });
  }, options);

  observer.observe(observeTarget);

  buttonElem.addEventListener('click', () => {
    infoElem.classList.remove('is-active');
    infoElem.classList.add('is-inactive');
  });
}


// ドロワーのアコーディオン
function initDrawerAccordion() {
  // アコーディオンのトリガー
  var triggers = document.querySelectorAll('.js-custom-sidebar-navigation__trigger');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var submenu = this.closest('.s-custom-sidebar-navigation__item').nextElementSibling;
      if (submenu && (submenu.className.includes('s-custom-sidebar-navigation__list--second') || submenu.className.includes('s-custom-sidebar-navigation__list--third'))) {
        if (submenu.clientHeight > 0) {
          submenu.style.height = '0';
        } else {
          submenu.style.height = submenu.scrollHeight + 'px';
        }
      }
    });
  });

  // 初期状態でサブメニューを非表示にする
  var submenus = document.querySelectorAll('.s-custom-sidebar-navigation__list--second, .s-custom-sidebar-navigation__list--third');
  submenus.forEach(function (submenu) {
    submenu.style.height = '0';
    submenu.style.overflow = 'hidden';
    submenu.style.transition = 'height 0.3s ease';
  });
}

// タグのアコーディオン
function initTagAccordion() {
  const tagAccordion = document.querySelector('#js-tag-accordion');
  if (!tagAccordion) return;

  const tagSelected = tagAccordion.querySelector('#js-tag-accordion-selected');
  tagSelected.addEventListener('click', () => {
    const tagList = tagAccordion.querySelector('#js-tag-accordion-list');

    if (tagList.style.maxHeight) {
      tagList.style.maxHeight = null;
      tagAccordion.classList.remove('is-open');
    } else {
      tagList.style.maxHeight = tagList.scrollHeight + "px";
      tagAccordion.classList.add('is-open');
    }
  });
}

// 固定背景がある場合のコンテンツに対する高さの調整
function updateHeight() {
  const element = document.getElementById('js-mv-bg');
  if (element) {
    const pageHeight = document.documentElement.scrollHeight;
    element.style.height = pageHeight + 'px';
  }
}

// collection all の絞り込み
function handleCheckboxChange() {
  const checkboxes = document.querySelectorAll('.js-custom-facets__checkboxes-checkbox');
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const newUrl = new URL(window.location.href);
      const searchParams = newUrl.searchParams;
      searchParams.delete(this.name);

      if (this.checked) {
        searchParams.append(this.name, this.value);
      }
      window.location.href = newUrl.toString();
    });
  });
}

//セット購入商品
const addCart = (button, sendData) => {
  const variantId = button.getAttribute('data-variant');
  const quantity = parseInt(button.getAttribute('data-quantity'), 10);
  const body = JSON.stringify({
    items: [{
      id: variantId,
      quantity: quantity,
      properties: {
        "セット対象": sendData.tiedTitle,
        "セットID": sendData.tiedId
      }
    }]
  });
  let alert = '';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body
  })
    .then(response => response.json())
    .then(response => {
      if (response.status == 422) {
        // wrong stock logic alert
        alert = document.createElement('span');
        alert.className = 'alert body-text-sm alert--error';
        alert.innerHTML = response.description
        return fetch('?section_id=cart-helper');
      } else {
        return fetch('?section_id=cart-helper');
      }
    })
    .then(response => response.text())
    .then(text => {

      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

      const cartItems = document.getElementById('AjaxCartForm');
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      if (alert != '') {
        document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
      }

      document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
      window.preloadImages(cartItems);

      document.querySelector('[data-header-cart-count]').textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
      if (document.querySelector('#AjaxCartForm [data-cart-count]').textContent == '0') {
        document.querySelector('[data-header-cart-count]').classList.add('visually-hidden');
      } else {
        document.querySelector('[data-header-cart-count]').classList.remove('visually-hidden');
      }

      // サイドバー表示
      window.preloadImages(document.getElementById('site-cart-sidebar'));
      document.getElementById('site-cart-sidebar').show();
      setTimeout(() => {
        document.querySelector('#site-cart-sidebar .close-sidebar').focus();
      }, 200);

    })
    .catch(error => {
      console.log('error', error);
    })
    .finally(() => {
      button.classList.remove('is-working');
    });

}
const addSetPurchaseProduct = (button) => {
  // ボタンからデータ属性を取得
  const variantId = button.getAttribute('data-variant');
  const productVariantId = button.getAttribute('data-product-variant');
  const productSellingPlanId = button.getAttribute('data-product-selling-plan-id');

  // カート内のアイテムを確認
  const cartItems = document.querySelectorAll('#AjaxCartForm .cart-item');
  let subscItemInCart = false; // 定期商品がカートにあるかどうか
  let subscItemInCartQty = 0; // 定期商品の数量
  let subscItemInCartSendData = {}; // 定期商品のデータ
  let setItemInCartQty = 0; // セット商品の数量

  cartItems.forEach((item) => {
    const itemVariantId = item.getAttribute('data-variant');
    const itemSellingPlanId = item.getAttribute('data-selling-plan-id');

    // 一致するアイテムが見つかったかどうかをチェック
    if (productVariantId === itemVariantId && productSellingPlanId === itemSellingPlanId) {
      const itemVariantQty = item.getAttribute('data-qty');
      const itemTitle = item.getAttribute('data-title');
      const sellingPlanText = item.querySelector('.info.selling-plan') ? item.querySelector('.info.selling-plan').textContent : '';
      const tiedTitle = `${itemTitle}-${sellingPlanText}`;
      const tiedId = `${itemVariantId}_${itemSellingPlanId}`;
      subscItemInCart = true;
      subscItemInCartQty = parseInt(itemVariantQty, 10);
      subscItemInCartSendData = {
        tiedTitle: tiedTitle.trim(),
        tiedId: tiedId
      };
    }
  });

  cartItems.forEach((item) => {
    const itemVariantId = item.getAttribute('data-variant');
    const itemTiedId = item.getAttribute('data-tied-id');
    if (variantId == itemVariantId && itemTiedId == subscItemInCartSendData.tiedId) {
      console.log("subscItemInCartSendData.tiedId", subscItemInCartSendData.tiedId);
      console.log("itemTiedId", itemTiedId);
      const itemVariantQty = item.getAttribute('data-qty');
      setItemInCartQty = setItemInCartQty + parseInt(itemVariantQty, 10);
    }
  });

  // 条件に合致するアイテムが見つかった場合の処理
  if (subscItemInCart) {
    if (subscItemInCartQty > setItemInCartQty) {
      addCart(button, subscItemInCartSendData);
    } else {
      alert('このセット購入特典の商品は追加済みです。');
      button.classList.remove('is-working');
      return;
    }
  } else {
    alert('定期購入商品をカートに追加後、セット購入特典の商品が追加できます。');
    button.classList.remove('is-working');
    return;
  }
}

function initSetPurchaseProduct() {
  const addSetPurchaseProductButtons = document.querySelectorAll('.js-add-set-purchase-product');
  if (!addSetPurchaseProductButtons) return;

  // IDの変更を検知して、ボタンのデータ属性を変更
  const idInput = document.querySelector('input[name="id"]');
  if (idInput) {
    idInput.addEventListener('change', function () {
      const newIdValue = this.value;
      addSetPurchaseProductButtons.forEach((button) => {
        button.setAttribute('data-product-variant', newIdValue);
      });
    });
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === "attributes" && mutation.attributeName === "value") {
        addSetPurchaseProductButtons.forEach((button) => {
          button.setAttribute('data-product-selling-plan-id', mutation.target.value);
        });
      }
    });
  });
  const targetNode = document.getElementById("mikawaya-hidden-selling-plan-id");
  if (targetNode) {
    observer.observe(targetNode, { attributes: true, attributeFilter: ['value'] });
  }

  addSetPurchaseProductButtons.forEach((button) => {
    button.addEventListener('click', () => {
      button.classList.add('is-working');
      addSetPurchaseProduct(button);
    });
  });
}


//言語切り替え
function initializeLanguageSwitcher() {
  const languageButtons = document.querySelectorAll('.js-language-button');

  languageButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const selectedLang = this.getAttribute('data-lang');

      // 言語切り替えのためのフォームを作成して送信
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization';

      const methodInput = document.createElement('input');
      methodInput.type = 'hidden';
      methodInput.name = '_method';
      methodInput.value = 'PUT';

      const sourceInput = document.createElement('input');
      sourceInput.type = 'hidden';
      sourceInput.name = 'source';
      sourceInput.value = 'geolocation_selector';

      const returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      returnToInput.value = window.location.pathname;

      const localeInput = document.createElement('input');
      localeInput.type = 'hidden';
      localeInput.name = 'locale_code';
      localeInput.value = selectedLang;

      form.appendChild(methodInput);
      form.appendChild(sourceInput);
      form.appendChild(returnToInput);
      form.appendChild(localeInput);

      document.body.appendChild(form);
      form.submit();
    });
  });
}











/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  handleContentLoaded();
  generateTOC();
  swiperSlide();
  initSmoothScroll();
  handlePageLoad();
  initializeAccordions();
  initializeLoadMore();
  observerLoadMore();
  observeVariantSelect();
  adjustQuantity();
  searchStore();
  subscriptionInfo();
  initDrawerAccordion();
  initTagAccordion();
  updateHeight();
  handleCheckboxChange();
  initSetPurchaseProduct();
  initializeLanguageSwitcher();
}, false);

/* ---------------------------------------------------------------------
shopify:section:load
--------------------------------------------------------------------- */
document.addEventListener('shopify:section:load', () => {
  handleContentLoaded();
  generateTOC();
  swiperSlide();
  initSmoothScroll();
  handlePageLoad();
  initializeAccordions();
  initializeLoadMore();
  observerLoadMore();
  observeVariantSelect();
  adjustQuantity();
  searchStore();
  subscriptionInfo();
  initDrawerAccordion();
  initTagAccordion();
  updateHeight();
  handleCheckboxChange();
  initSetPurchaseProduct();
  initializeLanguageSwitcher();
}, false);

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */

let currentWidth = window.innerWidth;
let resizeTimer = false;

const isPassiveSupport = () => {
  if (typeof window === 'object' && typeof window.addEventListener === 'function' && Object.defineProperty) {
    let passive = false;
    const options = Object.defineProperty({}, 'passive', {
      get() {
        passive = true;
        return passive;
      }
    });
    window.addEventListener('test', null, options);
    return passive;
  }
}

window.addEventListener('resize', () => {
  if (currentWidth == window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    swiperSlide();
    updateHeight();
    currentWidth = window.innerWidth;
  }, 200);
}, isPassiveSupport() ? { passive: true } : false);


/* ---------------------------------------------------------------------
load
--------------------------------------------------------------------- */

window.addEventListener('load', () => {
  updateHeight();
});

/* ---------------------------------------------------------------------
fetch  custom-product-recommendations.liquid
--------------------------------------------------------------------- */
document.addEventListener('fetchData', () => {
  swiperSlide();
  window.preloadImages(document.querySelector('.product-recommendations'));
}, false);